import React from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

export interface SEOProps {
  title: string
  description?: string
  ogDescription?: string
  url?: string
  image?: string
  meta?: (
    | {
        property?: string
        content?: string
      }
    | undefined
  )[]
  lang?: string
  schemaMarkup?: object
}

const SEO: React.FC<SEOProps> = ({ description, ogDescription, lang, meta, title, url, image, schemaMarkup }) => {
  const { site } = useStaticQuery<GatsbyTypes.SiteMetaQuery>(
    graphql`
      query SiteMeta {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site?.siteMetadata?.description
  const metaOgDescription = ogDescription || description || site?.siteMetadata?.description

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        metaDescription && {
          name: `description`,
          content: metaDescription
        },
        title && {
          property: `og:title`,
          content: title
        },
        metaOgDescription && {
          property: `og:description`,
          content: metaOgDescription
        },
        {
          property: `og:type`,
          content: `website`
        },
        url && {
          property: `og:url`,
          content: url
        },
        image && {
          property: `og:image`,
          content: image
        },
        lang && {
          property: `og:locale`,
          content: lang
        }
      ]
        .concat(meta)
        .filter(Boolean)}
    >
      {schemaMarkup && <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
}

export default SEO
